module.exports = __webpack_public_path__ + "img/h2h-banner.dcc8308a.png";